"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NUMBER_FORMAT_NAME = exports.RESERVED_NUMBER_FORMAT_NUM = exports.INVALID_VALUE = exports.DEFAULT_FORMAT = exports.DEFAULT_FORMAT_PATTERN = void 0;
/**
* 默认格式
* @const
*/
var DEFAULT_FORMAT_PATTERN = 'General';
exports.DEFAULT_FORMAT_PATTERN = DEFAULT_FORMAT_PATTERN;
/**
* 默认数值格式对象
* @const
*/
var DEFAULT_FORMAT = {
    id: 0,
    pattern: DEFAULT_FORMAT_PATTERN,
};
exports.DEFAULT_FORMAT = DEFAULT_FORMAT;
/**
* 异常日期格式
* excel 的日期/时间不合法时(parse_date_code 结果为 null), 数据格式化返回的结果
* 但是单元格展示不合法的功能只有 excel 有, google 和金山会依然展示用户输入
*/
var INVALID_VALUE = '#INVALID_DATE!';
exports.INVALID_VALUE = INVALID_VALUE;
/**
* 目前保留的格式 id, 未使用
* @const
*/
var RESERVED_NUMBER_FORMAT_NUM = 164;
exports.RESERVED_NUMBER_FORMAT_NUM = RESERVED_NUMBER_FORMAT_NUM;
/**
* 现有单元格格式标识
* @const
*/
var NUMBER_FORMAT_TYPE;
(function (NUMBER_FORMAT_TYPE) {
    NUMBER_FORMAT_TYPE["GENERAL"] = "auto";
    NUMBER_FORMAT_TYPE["TEXT"] = "text";
    NUMBER_FORMAT_TYPE["NUMBER"] = "number";
    NUMBER_FORMAT_TYPE["PERCENT"] = "percent";
    NUMBER_FORMAT_TYPE["CURRENCY"] = "currency";
    NUMBER_FORMAT_TYPE["DATE"] = "date";
    NUMBER_FORMAT_TYPE["TIME"] = "time";
    NUMBER_FORMAT_TYPE["DATE_TIME"] = "date-time";
    NUMBER_FORMAT_TYPE["FRACTION"] = "fraction";
    NUMBER_FORMAT_TYPE["SCIENTIFIC"] = "scientific";
    NUMBER_FORMAT_TYPE["ACCOUNTING"] = "accounting";
    NUMBER_FORMAT_TYPE["SPECIAL"] = "special";
    NUMBER_FORMAT_TYPE["CUSTOM"] = "custom";
})(NUMBER_FORMAT_TYPE || (NUMBER_FORMAT_TYPE = {}));
/**
* 现有单元格格式名称对象
* @const
*/
var NUMBER_FORMAT_NAME = [
    {
        type: NUMBER_FORMAT_TYPE.GENERAL,
        name: '常规'
    },
    {
        type: NUMBER_FORMAT_TYPE.TEXT,
        name: '文本'
    },
    {
        type: NUMBER_FORMAT_TYPE.NUMBER,
        name: '数值'
    },
    {
        type: NUMBER_FORMAT_TYPE.PERCENT,
        name: '百分比'
    },
    {
        type: NUMBER_FORMAT_TYPE.SCIENTIFIC,
        name: '科学记数'
    },
    {
        type: NUMBER_FORMAT_TYPE.CURRENCY,
        name: '货币'
    },
    {
        type: NUMBER_FORMAT_TYPE.TIME,
        name: '时间'
    },
    {
        type: NUMBER_FORMAT_TYPE.DATE,
        name: '日期'
    },
    {
        type: NUMBER_FORMAT_TYPE.DATE_TIME,
        name: '日期'
    },
    {
        type: NUMBER_FORMAT_TYPE.ACCOUNTING,
        name: '会计专用'
    },
    {
        type: NUMBER_FORMAT_TYPE.FRACTION,
        name: '分数'
    },
    {
        type: NUMBER_FORMAT_TYPE.SPECIAL,
        name: '特殊'
    },
    {
        type: NUMBER_FORMAT_TYPE.CUSTOM,
        name: '自定义'
    },
];
exports.NUMBER_FORMAT_NAME = NUMBER_FORMAT_NAME;
//# sourceMappingURL=number-format-const.js.map